import { useMemo } from 'react'

import { useSpiralEffectSkins } from '@store'

export const useSpirals = () => {
  const spirals = useSpiralEffectSkins()

  const sortedSpirals = useMemo(() => {
    return spirals.sort((a) => (a.isAvailable ? -1 : 1))
  }, [spirals])

  return { spirals: sortedSpirals }
}
